export const NEW_FORM_BTN_ID = 'new-form-cta';

export const pollForEmailSignupFormPreview = (id: string) => {
  if (typeof window.PMW.formMaker === 'undefined') {
    window.PMW.getJsAndCssAssetGroup('formMakerDialog', pollForEmailSignupPreview.bind(this, id));
  } else {
    pollForEmailSignupPreview(id);
  }
};

function pollForEmailSignupPreview(id: string): void {
  window.PMW.formMaker.grid.pollForEmailSignupFormPreview(id);
}
